import React from "react";
import { OrderTableQuery } from "../models";
import { Table, useAuth } from "../../../components";
import { useCustomTranslation } from "../../../helpers/translateHelpers";
import { getTablePageCount } from "../../../helpers/tableHelpers";
import { renderDate } from "../../../helpers/dayjsHeleprs";
import { useNavigate } from "../../../helpers/navigationHelpers";
import { CPOrder, TableResultCPOrder } from "../../../api/models/unified";
import { ExtendedColumn } from "../../../components/table/Table";

interface Props {
  data?: TableResultCPOrder;
  setQueryParams: (params: OrderTableQuery) => void;
  queryParams: OrderTableQuery;
  loading?: boolean;
}

const OrdersTable: React.FC<Props> = (props): React.ReactElement => {
  const { data, queryParams, setQueryParams, loading } = props;

  const { tOrder } = useCustomTranslation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const columns: ExtendedColumn<CPOrder>[] = [
    {
      key: "created",
      name: tOrder("created"),
      renderCell: ({ row }) => renderDate(row.created),
      sortable: true,
    },
    {
      key: "customerName",
      name: tOrder("customer"),
      sortable: true,
      hidden: !user?.isInvoiceCustomer,
    },
    {
      key: "invoiceCustomerName",
      name: tOrder("invoice_customer"),
      sortable: true,
      hidden: !user?.hasOrdersWithInvoiceCustomer,
    },
    { key: "code", name: tOrder("code"), sortable: true },
    {
      key: "state",
      name: tOrder("state"),
      renderCell: ({ row }) => tOrder(`state_${row.state}`),
      sortable: true,
    },

    { key: "categoryName", name: tOrder("category"), sortable: true },
    { key: "oneLinerAddress", name: tOrder("address"), sortable: true },
    {
      key: "completedAt",
      name: tOrder("completed"),
      renderCell: ({ row }) => renderDate(row.completedAt),
      sortable: true,
    },
  ];

  return (
    <Table
      columns={columns}
      data={data?.data ?? []}
      onTableQueryChange={setQueryParams}
      queryParams={queryParams}
      pageCount={getTablePageCount(data?.total ?? 1, queryParams.pageSize)}
      loading={loading}
      onRowClick={(item) => navigate.goTo(`orders/${item.id}`)}
    />
  );
};

export default OrdersTable;
